<template>
    <v-card flat class="transparent">
      <v-layout align-center justify-center row fill-height wrap>
        <v-flex xs12 sm4 class="text-xs-center text-sm-left">
          <sv-avatar size="120" />
        </v-flex>
        <v-flex xs12 sm8 class="text-xs-center text-sm-left">
          <v-card-text class="pl-0">
            <div>
              <div class="headline">{{contactInfo.name}}</div>
              <div>
                Tel: <a :href="`tel:${contactInfo.tel}`">{{contactInfo.tel}}</a>
              </div>
              <div>
                <a :href="`mailto:${contactInfo.email}`">{{contactInfo.email}}</a>
              </div>
              <div>{{contactInfo.address.street}} {{contactInfo.address.houseNumber}}</div>
              <div>{{contactInfo.address.postalCode}} {{contactInfo.address.city}}</div>
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    contactInfo() {
      return this.$store.getters.contactInfo;
    },
    contactPhoto() {
      return require("@/assets/sv/profile.jpg");
    }
  },
  methods: {}
};
</script>

<style>
</style>
